// @ts-nocheck

import React from 'react';
import { View, Image, StyleSheet, TouchableWithoutFeedback, Text } from 'react-native';
import { lrpx } from "../../HalfScreenCashier/common/utils";
const styles = StyleSheet.create({
  layout: {
    width: '100%',
    backgroundColor: '#FFF',
    borderTopLeftRadius: lrpx(16),
    borderTopRightRadius: lrpx(16),
    paddingTop: lrpx(24),
    paddingBottom: lrpx(32)
  },
  cLayout: {
    paddingTop: lrpx(32)
  },
  close: {
    width: lrpx(24),
    height: lrpx(24),
    position: 'absolute',
    zIndex: 9999,
    top: lrpx(20),
    right: lrpx(21.5)
  },
  header: {
    paddingTop: lrpx(18),
    paddingBottom: lrpx(17),
    borderBottomColor: '#EAEAEA',
    borderBottomWidth: StyleSheet.hairlineWidth
  },
  title: {
    color: '#222',
    fontSize: lrpx(24),
    lineHeight: lrpx(28),
    fontWeight: '700',
    textAlign: 'center',
    marginBottom: lrpx(19)
  },
  cTitle: {
    fontSize: lrpx(14),
    lineHeight: lrpx(16),
    marginBottom: lrpx(8),
    textAlign: 'center'
  }
});
const closeIcon = 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAYAAABXAvmHAAAACXBIWXMAABYlAAAWJQFJUiTwAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAGgSURBVHgB7ZjRbcJAEETXTgGEBoASTAeUknSQDjAVpISEElJBkgqSEmwqMBU4OwikE7LBezf3EWmfhIQX2J3hrLsBEcdxHMdx/hkrZbFY1EJGe76it+UzpRjBgL7vP4ui2OrANyGBXtrzBb0tJgoxoH0fdcAPnl5qev1+OByeJYGz+Keg1Oj1umma7t5nTSuAhtp4H9YwOGUlBsTjS9lPEQ8exEjXdV/z+Rwrt7nUVEA1m81Wx+PxQwyMiN/pitYTW9gNAIYJhngQZQCkmGCJB9EGQIwJpniQZABYTLDFg2QDYIqJHOJPc4SInhO1itqGNZwTp0EZxAPKClwYWwk8wvexxAOqATBkIoQpHlBvoZDlconIUV2Vf9u2XQsRc5ibwjlaVAMvVcwACOi30NBuExIbO8agGhjbKsuy/BZCdhqCZuDWPs8MgNdQDEw5pHKZSDZgOWFzmEgyEBMP2CaiDaRkG6aJKAOMYMYyYTbATJUME+aTWPf0NrxOzTb6471W0burcis5QWzWrNMz/9zK0fPewI2QydHTcRzHcRznBn9Lfky7gUKctgAAAABJRU5ErkJggg==';
const PopupLayout = props => {
  const {
    title,
    children,
    style,
    close,
    type = 'separate',
    cTitle
  } = props;
  const handleClose = () => {
    close && close();
  };

  // 子组件
  const child = /*#__PURE__*/React.isValidElement(children) ? /*#__PURE__*/React.cloneElement(children, {
    close: () => {
      var _children$props;
      handleClose();
      if (typeof ((_children$props = children.props) === null || _children$props === void 0 ? void 0 : _children$props.close) === 'function') {
        var _children$props2, _children$props2$clos;
        (_children$props2 = children.props) === null || _children$props2 === void 0 ? void 0 : (_children$props2$clos = _children$props2.close) === null || _children$props2$clos === void 0 ? void 0 : _children$props2$clos.call(_children$props2);
      }
    }
  }) : null;

  // 两个布局细节实现上差异较多，分开写
  if (type === 'common') {
    return /*#__PURE__*/React.createElement(View, {
      style: [styles.layout, styles.cLayout, style]
    }, child);
  }
  return /*#__PURE__*/React.createElement(View, {
    style: [styles.layout, style]
  }, /*#__PURE__*/React.createElement(TouchableWithoutFeedback, {
    onPress: handleClose
  }, /*#__PURE__*/React.createElement(Image, {
    source: {
      uri: closeIcon
    },
    style: styles.close
  })), cTitle ? /*#__PURE__*/React.createElement(Text, {
    style: styles.cTitle
  }, cTitle) : null, title ? /*#__PURE__*/React.createElement(Text, {
    style: styles.title
  }, title) : null, child);
};
export default PopupLayout;